export default __webpack_public_path__ + "static/media/counter2.baec8ef2.png";